import { type BotHardwareEquipmentType } from './types';

/**
 * Auto Reviewer User ID
 * This is a system user used for automated validation and review processes.
 * Defined in migration 0169_create_auto_reviewer_user
 */
export const AUTO_REVIEWER_USER_ID = 'user_0sapi_0X7mK9pQ2vN4rT6wY8zB';

/**
 * Default Recording User ID
 * This is the default user ID used for recordings (including inference recordings)
 * when no user ID is explicitly provided.
 * Used in CreateRecording step and other recording contexts.
 */
export const DEFAULT_RECORDING_USER_ID = 'user_0sapi_saa1nUhOxcvsd436sgf35f';

export const BOT_HARDWARE_EQUIPMENT_TYPE_TO_DATA_TYPES: {
  [key in BotHardwareEquipmentType]: {
    label: string;
    dataTypes: Array<{ value: string; label: string }>;
  };
} = {
  robot: {
    label: 'Robot',
    dataTypes: [
      {
        value: 'pose',
        label: 'Pose',
      },
      {
        value: 'joint_states',
        label: 'Joint States',
      },
      {
        value: 'teleop_command',
        label: 'Teleop Command',
      },
    ],
  },
  camera: {
    label: 'Camera',
    dataTypes: [{ value: 'video', label: 'Video' }],
  },
  depth_sensor: {
    label: 'Depth Sensor',
    dataTypes: [{ value: 'depth_image', label: 'Depth Image' }],
  },
  gripper: {
    label: 'Gripper',
    dataTypes: [{ value: 'gripper', label: 'Gripper' }],
  },
  force_sensor: {
    label: 'Force Sensor',
    dataTypes: [{ value: 'force_hardware', label: 'Force Hardware' }],
  },
};
